import type {
  RequestSagaActionCreator,
  RequestLifeCycles,
} from './action-types';

export function createRequestAction<Payload, Type extends string = string>(
  type: Type
): RequestSagaActionCreator<Payload, Type>;
export function createRequestAction(type) {
  const actions: RequestLifeCycles = {
    request: `${type}/REQUEST`,
    success: `${type}/REQUEST_SUCCESS`,
    failure: `${type}/REQUEST_ERROR`,
  };

  const actionCreator = (payload) => {
    return {
      type,
      payload,
      actions,
      response: {},
    };
  };

  actionCreator.type = type;
  actionCreator.actions = actions;
  actionCreator.request = actions.request;
  actionCreator.success = actions.success;
  actionCreator.failure = actions.failure;

  return actionCreator;
}
